import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertMoney'
})
export class ConvertMoneyPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return 'R$ ' + value;
  }

}
